import { render } from "./Quizz2D.vue?vue&type=template&id=ba67c3ac&scoped=true"
import script from "./Quizz2D.vue?vue&type=script&lang=js"
export * from "./Quizz2D.vue?vue&type=script&lang=js"

import "./Quizz2D.vue?vue&type=style&index=0&id=ba67c3ac&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba67c3ac"]])

export default __exports__